import { z } from "zod";
import { BRAZIL_UFS } from "@cx/domain";

const date = z
  .string()
  .regex(/^\d{4}-\d{2}-\d{2}$/)
  .optional()
  .catch(undefined);
/** Situações escolhidas no filtro (ids por vírgula); ausente = as da configuração. */
const statuses = z
  .string()
  .regex(/^[0-9A-Z,]{1,1000}$/)
  .optional()
  .catch(undefined);

/** Filtros na URL (inválido vira undefined = padrão do servidor). */
export const dashboardSearch = z.object({
  from: date,
  to: date,
  compareFrom: date,
  compareTo: date,
  statuses,
});
export type DashboardSearch = z.output<typeof dashboardSearch>;
/** Consolidado (T3.10): empresas por vírgula (ausente = todas as que o usuário vê) e a eliminação intercompanhia. */
export const consolidatedSearch = z.object({
  from: date,
  to: date,
  compareFrom: date,
  compareTo: date,
  companies: z
    .string()
    .regex(/^[0-9A-Z,]{1,1000}$/)
    .optional()
    .catch(undefined),
  intercompany: z.enum(["eliminate", "include"]).optional().catch(undefined),
});
export const dailySearch = z.object({ date, compareDate: date, statuses });
export const salesOrdersSearch = z.object({
  from: date,
  to: date,
  uf: z.enum(BRAZIL_UFS).optional().catch(undefined),
  statuses,
});
export const rankingSearch = z.object({
  month: z
    .string()
    .regex(/^\d{4}-\d{2}$/)
    .optional()
    .catch(undefined),
  statuses,
});
export const goalsSearch = z.object({
  state: z.enum(["current", "future", "past", "all"]).optional().catch(undefined),
});

/** Lista de situações da URL. */
export const statusList = (s: string | undefined) => (s ? s.split(",").filter(Boolean) : undefined);
